// extracted by mini-css-extract-plugin
var _1 = "AdminProvisionForm-module__footer--IvBnB";
var _2 = "AdminProvisionForm-module__section--sIWn0";
var _3 = "AdminProvisionForm-module__titleRow--uauzJ";
var _4 = "AdminProvisionForm-module__urlButtons--J1QqV";
export { _1 as "footer", _2 as "section", _3 as "titleRow", _4 as "urlButtons" }
